import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import {
  CurrentWeatherConditionsTile,
  DailyWeatherConditionsTile,
  HourlyWeatherForecastTile,
  LocationManager,
  SideDrawerModal,
  TWCText,
  TWCTileButton,
} from '@components';

import { assets } from '@assets';
import { locationsIDs, myWeatherPageTestIDs } from '@constants';
import { helpers } from '@helpers';
import { useAppContextReference, useContextNodeHandles, useGetUserLocation } from '@hooks';

import { styles } from './styles';

const tPath = 'myWeatherPage.';

export const MyWeatherMiddleRow = () => {
  const { t } = useTranslation();
  const isPageFocused = useIsFocused();

  const { city } = useGetUserLocation();

  const [isLocationModalVisible, setLocationModalVisible] = useState(false);

  const lastRoute = useAppContextReference('lastRoute');

  useEffect(() => {
    if (isLocationModalVisible) {
      lastRoute.current = locationsIDs.changeLocationModal;
    } else if (isPageFocused) {
      lastRoute.current = 'MainMenu';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLocationModalVisible, isPageFocused]);

  const [
    currentWeatherConditionsTileHandle,
    hourlyForecastTileTileHandle,
    dailyForecastTileHandle,
    changeLocationButtonHandle,
    liveVideoHandle,
    mapHandle,
  ] = useContextNodeHandles([
    myWeatherPageTestIDs.currentWeatherConditionsTile,
    myWeatherPageTestIDs.hourlyForecastTile,
    myWeatherPageTestIDs.dailyForecastTile,
    myWeatherPageTestIDs.changeCityButton,
    myWeatherPageTestIDs.liveVideoPlayerTile,
    myWeatherPageTestIDs.liveMapTile,
  ]);

  const onHandleClose = () => {
    setLocationModalVisible(false);
    if (helpers.isWeb) {
      helpers.FOCUS_NOW(changeLocationButtonHandle);
    }
  };

  return (
    <View style={styles.middleRowWrapper}>
      <TWCText
        style={styles.tileHeader}
        testID={myWeatherPageTestIDs.locationHeader}
        variant={'tileHeader'}
      >{`${city} ${t(`${tPath}cityWeatherText`)}`}</TWCText>
      <View style={styles.rowWrapper}>
        <CurrentWeatherConditionsTile.API
          nextFocusDown={currentWeatherConditionsTileHandle}
          nextFocusRight={hourlyForecastTileTileHandle}
          nextFocusUp={liveVideoHandle}
          nextFocusLeft={null}
        />
        <HourlyWeatherForecastTile.API
          nextFocusLeft={currentWeatherConditionsTileHandle}
          nextFocusRight={dailyForecastTileHandle}
          nextFocusUp={liveVideoHandle}
          nextFocusDown={null}
        />
        <DailyWeatherConditionsTile.API
          nextFocusLeft={hourlyForecastTileTileHandle}
          nextFocusRight={changeLocationButtonHandle}
          nextFocusUp={mapHandle}
          nextFocusDown={null}
        />
        <TWCTileButton
          active
          accessibilityHint={t(`${tPath}changeCityButton.accessibilityHint`)}
          accessibilityLabel={t(`${tPath}changeCityButton.title`)}
          nextFocusLeft={dailyForecastTileHandle}
          nextFocusUp={mapHandle}
          testID={myWeatherPageTestIDs.changeCityButton}
          title={t(`${tPath}changeCityButton.title`)}
          onPress={() => setLocationModalVisible(true)}
        >
          <View style={styles.changeCityIconContainer}>
            <Image
              accessibilityIgnoresInvertColors
              source={assets.locationImageSource}
              style={styles.changeCityIcon}
              testID={myWeatherPageTestIDs.changeCityIcon}
            />
          </View>
        </TWCTileButton>
        <SideDrawerModal handleClose={onHandleClose} visible={isLocationModalVisible}>
          <LocationManager />
        </SideDrawerModal>
      </View>
    </View>
  );
};
